import VTooltip from 'v-tooltip';

export default (vue) => {
    vue.use(VTooltip);
    VTooltip.options.defaultClass = 'vueTooltip';
};
